let cart;

/**
 * Will asynchronously update an item in cart
 * @param {CartItem} item
 * @param {number} quantity
 * @param {object} properties
 * @returns
 */
async function updateItem(item, quantity, properties = {}) {
  // Will find the line item line
  const line = cart.items.findIndex((cartItem) => cartItem.id === item.id);
  if (line == -1) return console.log("Invalid line");

  const data = {
    line: `${line + 1}`,
    quantity: `${quantity}`,
    properties,
  };
  const body = JSON.stringify(data, null, 2);

  await fetch("/cart/change.js", {
    method: "POST",
    credentials: "same-origin",
    body,
    headers: {
      "content-type": "application/json",
    },
  }).then(async (res) => {
    cart = await res.json();
  });
}

/**
 * Will return participant DOM inputs related to line item
 * @param {CartItem} courseItem
 * @returns
 */
function getCartItemParticipantInputs(courseItem) {
  const selector = `[data-item-id="${courseItem.id}"]`;
  const elem = document.querySelector(selector);
  const participantInputs = Array.from(
    elem.querySelectorAll(".participants-field-list input")
  );
  return participantInputs;
}

/** Automatically init/bind course product present in checkout  */
(async function bindCheckoutCourses() {
  cart = await fetch("/cart.js").then((res) => res.json());
  const courseItems = cart.items.filter(
    ({ product_type }) => product_type === "Course"
  );

  if (!courseItems.length) return;

  // Create input element
  const _makeParticipantInput = (value = "") => {
    const wrapper = document.createElement("div");
    wrapper.classList.add("participants-input-field");
    const input = document.createElement("input");
    input.type = "text";
    input.placeholder = "Enter participant name.";
    input.pattern = "^[A-Za-z_ ]*$";
    input.value = value;
    input.required = true;
    wrapper.append(input);
    return wrapper;
  };

  /**
   *  Will init and bind a "Course" product
   */
  function _bindCourseItem(courseItem) {
    const selector = `[data-item-id="${courseItem.id}"]`;
    const elem = document.querySelector(selector);
    const qtyInput = elem.querySelector(".quantity input");
    const participantsList = elem.querySelector(".participants-field-list");
    let currentQty = parseInt(qtyInput.value);
    let participants = courseItem.properties?.Participants || "";

    function __watchParticipantNameChange() {
      const participantInputs = getCartItemParticipantInputs(courseItem);
      const participantNames = participantInputs
        .map((input) => input.value)
        .filter((str) => /^[a-zA-ZÀ-ú\s]*(-[A-Z][a-zA-ZÀ-ú]*)*$/.test(str))
        .filter((val) => val.trim());
      const newParticipantsStr = participantNames.join(", ");

      if (newParticipantsStr === participants) return;
      updateItem(courseItem, currentQty, {
        Participants: newParticipantsStr,
      });
      participants = newParticipantsStr;
    }

    // Will fill in existing properties[Participants] names
    function __bindExistingNameInputs(participants) {
      const participantInputs = getCartItemParticipantInputs(courseItem);
      participants
        .split(",")
        .map((str) => str.trim())
        .filter((str) => /^[a-zA-ZÀ-ú\s]*(-[A-Z][a-zA-ZÀ-ú]*)*$/.test(str))
        .forEach(
          (participant, idx) => (participantInputs[idx].value = participant)
        );

      participantInputs.forEach((input) =>
        input.addEventListener("change", __watchParticipantNameChange)
      );
    }
    __bindExistingNameInputs(participants);

    // Wil watch and handle updating num of field inputs and their values
    qtyInput.addEventListener("change", ({ target }) => {
      const value = parseInt(target.value);
      const isInt = Number.isInteger(value);
      if (!isInt) return (target.value = currentQty);
      if (currentQty === value) return;
      if (value < 0) {
        const calcVal = currentQty + value;
        if (calcVal <= 0) {
          const shouldDelete = confirm(
            "Are you sure you want to remove this item?"
          );
          if (shouldDelete) {
            updateItem(courseItem, 0).then(() => window.location.reload());
          } else {
            target.value = currentQty;
          }
        } else {
          currentQty = calcVal;
        }
      } else {
        currentQty = value;
      }
      target.value = currentQty;
      participantsList.innerHTML = "";

      const currentParticipants = participants
        .split(",")
        .map((str) => str.trim());

      const participantInputs = Array.from(Array(currentQty)).map((_, idx) =>
        _makeParticipantInput(currentParticipants[idx])
      );
      participantInputs.forEach((input) =>
        input.addEventListener("change", __watchParticipantNameChange)
      );

      participantsList.append(...participantInputs);
      const updatedParticipantsStr = currentParticipants
        .slice(0, currentQty)
        .join(", ");

      // Saves item to cart
      updateItem(courseItem, currentQty, {
        Participants: updatedParticipantsStr,
      });
      participants = updatedParticipantsStr;
    });
  }
  courseItems.forEach(_bindCourseItem);

  function _validateCourseParticipants(courseItem) {
    const participantInputs = getCartItemParticipantInputs(courseItem);
    let isValid = true;

    /**
     * @param {HTMLInputElement} input
     */
    function _validateInput(input) {
      const { value } = input;
      const removeInvalidState = () =>
        input.parentElement.classList.remove("invalid");
      const hasValue = value.trim()
      const hasValidCharacters = /^[a-zA-ZÀ-ú\s]*(-[A-Z][a-zA-ZÀ-ú]*)*$/.test(value)
      if (!hasValue || !hasValidCharacters) {
        input.parentElement.classList.add("invalid");
        input.addEventListener("input", removeInvalidState, { once: true });
        isValid = false;
      } else input.parentElement.classList.remove("invalid");
    }
    participantInputs.forEach(_validateInput);

    return isValid;
  }

  /** @type {HTMLFormElement} */
  const cartForm = document.querySelector("#cartform");
  const submitButtons = Array.from(
    cartForm.querySelectorAll('input[type="submit"]')
  );
  const additionalCheckoutOptions = document.querySelector(
    ".additional-checkout-buttons"
  );
  /**
   * Capture cart form submission to add run validation
   * @param {Event} evt
   */
  function _captureFormSubmit(evt) {
    const validations = courseItems.map(_validateCourseParticipants);
    const isFalse = (value) => value === false;
    if (validations.some(isFalse)) {
      evt.preventDefault();
      evt.stopPropagation();
      return console.warn("Invalid Form");
    }
    if (evt.target.name === "update") window.location.reload();
    else if (evt.target.name === "checkout") window.location = "/checkout";
  }

  cartForm.addEventListener("submit", _captureFormSubmit);
  submitButtons.forEach((btn) =>
    btn.addEventListener("click", _captureFormSubmit)
  );
  additionalCheckoutOptions.addEventListener("click", _captureFormSubmit, {
    capture: true,
  });
})();

(function () {
  'use strict';

  var targetPath = '/products/instructor-certification-2';
  var variantId = '50274504474863';
  var applyUrl =
    'https://docs.google.com/forms/d/e/1FAIpQLSd__KbBTTGdNlqv7Grl4_gTD6SqyAnkZVD8VWjOTHf1t1QQww/viewform';

  var currentPath = window.location.pathname.replace(/\/+$/, '');

  if (currentPath !== targetPath) {
    return;
  }

  function addStyles() {
    if (document.getElementById('instructor-application-styles')) {
      return;
    }

    var style = document.createElement('style');

    style.id = 'instructor-application-styles';

    style.textContent = [
      '.pricearea-wrapper {',
      '  display: none !important;',
      '}',
      '',
      '#instructor-certification-apply {',
      '  display: block !important;',
      '  width: 100% !important;',
      '  box-sizing: border-box !important;',
      '  text-align: center !important;',
      '  text-decoration: none !important;',
      '}'
    ].join('\n');

    document.head.appendChild(style);
  }

  function updateProductControls() {
    addStyles();

    /*
     * Hide the price, "/ person," and Affirm messaging.
     */
    document
      .querySelectorAll('.pricearea-wrapper')
      .forEach(function (priceArea) {
        priceArea.style.setProperty(
          'display',
          'none',
          'important'
        );
      });

    /*
     * Find the product controls using the exact variant ID.
     */
    var variantInput = document.querySelector(
      'input[name="id"][value="' + variantId + '"]'
    );

    var productOptions = variantInput
      ? variantInput.closest('.productoptions.section')
      : document.querySelector(
          '#product_form_9483999707375 .productoptions.section'
        );

    if (!productOptions) {
      return;
    }

    /*
     * Remove the unavailable message.
     */
    productOptions
      .querySelectorAll('p')
      .forEach(function (element) {
        element.remove();
      });

    /*
     * Remove the Back in Stock notification button.
     */
    productOptions
      .querySelectorAll(
        '#BIS_trigger, .notifyMe, button'
      )
      .forEach(function (element) {
        element.remove();
      });

    /*
     * Add the application button.
     */
    var applyButton = productOptions.querySelector(
      '#instructor-certification-apply'
    );

    if (!applyButton) {
      applyButton = document.createElement('a');

      applyButton.id = 'instructor-certification-apply';
      applyButton.className = 'button';
      applyButton.href = applyUrl;
      applyButton.target = '_blank';
      applyButton.rel = 'noopener noreferrer';
      applyButton.textContent = 'Apply';

      productOptions.appendChild(applyButton);
    }
  }

  function initialize() {
    updateProductControls();

    /*
     * Back in Stock loads asynchronously and may recreate its button.
     */
    var observer = new MutationObserver(function () {
      updateProductControls();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    /*
     * Additional delayed passes for Shopify applications.
     */
    window.setTimeout(updateProductControls, 250);
    window.setTimeout(updateProductControls, 750);
    window.setTimeout(updateProductControls, 1500);
    window.setTimeout(updateProductControls, 3000);
    window.setTimeout(updateProductControls, 5000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize,
      { once: true }
    );
  } else {
    initialize();
  }
})();